module.exports = {
  "country": "MT",
  "artist": "Destiny",
  "song": "Je me casse",
  "year": "2021",
  "place": "7",
  "spotify": "559RWsQqSe4fNUffI9P7mW"
};